var paginationConfig = {};
export default {
  light: paginationConfig,
  dark: paginationConfig,
  white: paginationConfig
};